import { Outlet, createRoute } from '@tanstack/react-router'

import { entityRoute } from '@/app/routes/entity-route'
import { AreaSidebar, ProductGuard, ProductLayout, useAppContext } from '@/app/routes/area-layout'

import { CanvasCollectionsNav, CanvasShell } from './lazy-shell'

export function CanvasLayout() {
  const { entityId } = canvasRoute.useParams()
  const { sidebarCollapsed } = useAppContext()

  return (
    <ProductGuard product="canvas">
      <CanvasShell key={entityId.toLowerCase()}>
        <ProductLayout
          sidebar={
            <AreaSidebar area="canvas">
              <CanvasCollectionsNav collapsed={sidebarCollapsed} />
            </AreaSidebar>
          }
        >
          <Outlet />
        </ProductLayout>
      </CanvasShell>
    </ProductGuard>
  )
}

export const canvasRoute = createRoute({
  getParentRoute: () => entityRoute,
  path: 'canvas',
  component: CanvasLayout,
})
